import { setAssetsRegistry } from "@nectary/assets/utils";
import { setNectaryRegistry } from "@nectary/components/utils";
import { createShadowRoot } from "@sinch/mfe-helper-react";
import type { MFE } from "@sinch/mfe-types";
import { StrictMode } from "react";
// eslint-disable-next-line react/no-deprecated
import { render, unmountComponentAtNode } from "react-dom";
import { StyleSheetManager } from "styled-components";
import { App } from "./App";
import { GlobalStyle } from "./style/globalStyles";

// Having this defined outside of `mount()` will make sure it does
// not contain its scope if it happens to hang around in the host app.
const createUnmounter = (element: HTMLElement | ShadowRoot) => () => {
  unmountComponentAtNode(element);
};

const customRegistry = new CustomElementRegistry();
setNectaryRegistry(customRegistry);
setAssetsRegistry(customRegistry);

const mount: MFE = (element: HTMLDivElement) => {
  const { shadowRoot, appElement } = createShadowRoot(
    element,
    customRegistry,
    "Menu"
  );
  appElement.style.height = "100%";
  appElement.style.width = "100%";

  render(
    <StyleSheetManager target={shadowRoot}>
      <StrictMode>
        <GlobalStyle />
        <App />
      </StrictMode>
    </StyleSheetManager>,
    appElement
  );

  return createUnmounter(appElement);
};

// eslint-disable-next-line no-restricted-syntax
export default mount;
